import script from "./ChooseRadioButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseRadioButton.vue?vue&type=script&setup=true&lang=js"

import "./ChooseRadioButton.vue?vue&type=style&index=0&id=43c15db2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c15db2"]])

export default __exports__